<template>
  <tr :class="rowClass">
    <td>
      <span class="bold">{{ template.title }}</span>
      <p class="only-mobile text-xs text-gray-600">
        {{ truncate(template.description, 100) }}
      </p>
    </td>
    <td class="hide-mobile">{{ template.systemName }}</td>
    <td class="hide-mobile">{{ template.description }}</td>
    <td class="hide-mobile">{{ template.templateType }}</td>
    <td class="actions">
      <!-- Temporarily preventing selection of more than one template until we decide how we want the multi-template functionality to work.-->
      <action-button
        v-if="
          currentTemplates.indexOf(template.systemName) == -1 &&
            currentTemplates.length == 0
        "
        icon="fa-link"
        @click="linkClicked"
      ></action-button>
      <action-button
        v-if="currentTemplates.indexOf(template.systemName) > -1"
        icon="fa-unlink"
        @click="unlinkClicked"
      ></action-button>
    </td>
  </tr>
</template>
<script>
import currentTempates from "@/mixins/currentTemplates";
import tableRow from "@/mixins/tableRow";
import { truncate } from "@/util/stringUtil";

export default {
  mixins: [tableRow, currentTempates],
  props: ["template"],
  emits: ["link"],
  methods: {
    truncate,
    linkClicked: function() {
      this.$emit("link", this.template);
    },
    unlinkClicked: function() {
      this.$emit("unlink", this.template);
    },
  },
};
</script>
<style lang="scss" scoped>
.actions {
  white-space: nowrap;
}
</style>
